// extracted by mini-css-extract-plugin
export var cardIcon = "styles-module__cardIcon___lR5lj";
export var couponButton = "styles-module__couponButton___lASit";
export var couponCol = "styles-module__couponCol___ocCpU";
export var inactive = "styles-module__inactive____mnzz";